
import { AlertTriangle } from "lucide-react";

interface ProfileHeaderProps {
  isComplete: boolean;
  isEditMode: boolean;
  redirectReason?: string | null;
}

export const ProfileHeader = ({ 
  isComplete, 
  isEditMode, 
  redirectReason
}: ProfileHeaderProps) => {
  // Show the header if profile is not complete, regardless of edit mode if redirected for booking or ToS
  const isRedirectFlow = redirectReason === 'booking' || redirectReason === 'tos';
  const shouldShowWarning = !isComplete && (!isEditMode || isRedirectFlow);
  
  if (!shouldShowWarning) return null;
  
  return (
    <div className="mb-6 p-4 border-l-4 border-amber-500 bg-amber-50 rounded-r-md flex items-start">
      <AlertTriangle className="h-5 w-5 text-amber-500 mr-3 mt-0.5 flex-shrink-0" />
      <div>
        <h3 className="font-medium text-amber-800">Complete Your Profile</h3>
        <p className="text-amber-700 text-sm mt-1">
          {redirectReason === 'tos' 
            ? "Please complete your contact information to finish setting up your account."
            : "To book services, please complete your contact information (display name, phone number, address, and Google Maps location)."
          }
        </p>
      </div>
    </div>
  );
};
